import React from 'react';
import classnames from 'classnames';
import { useRouteMatch } from 'react-router-dom';
import styles from './AppLayout.module.scss';
import { GroupsSidebar, ProfileDrawer, ErrorBoundary } from 'components';

export const AppLayout: React.FC = (props) => {
  const isSettingsRoute = useRouteMatch({
    path: '/settings',
    exact: true,
    strict: true,
    sensitive: true,
  });

  const isProfileRoute = useRouteMatch({
    path: '/profile',
    exact: false,
    strict: false,
    sensitive: true,
  });

  const isGroupRoute = useRouteMatch({
    path: '/group',
    exact: false,
    strict: false,
    sensitive: true,
  });

  const showTickerNav = !isSettingsRoute && !isProfileRoute && !isGroupRoute;

  return (
    <ErrorBoundary>
      <div className={styles.container}>
        <div className={classnames(styles.content, showTickerNav && styles.hasTickerNav)}>
          {props.children}
        </div>
      </div>
      <GroupsSidebar />
      <ProfileDrawer />
    </ErrorBoundary>
  );
};
